// extracted by mini-css-extract-plugin
export default {"pageTitle":"components-header-nav-bar-styles-navbar-module__pageTitle--VNEvcnwo6CjL5xoi49xi2w=="};